'use strict';

(() => {
  const root = document.querySelector('[data-vice-storefront]');
  if (!root) return;

  const productReady = root.dataset.productReady === 'true';
  const cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
  const checkoutUrl = root.dataset.checkoutUrl || '/checkout';

  const views = [
    { url: root.dataset.frontUrl, title: 'FRONT VIEW', alt: 'Front view of the Sunset Edition controller' },
    { url: root.dataset.rightUrl, title: 'RIGHT SIDE', alt: 'Right side of the Sunset Edition controller' },
    { url: root.dataset.backUrl, title: 'REAR VIEW', alt: 'Rear view of the Sunset Edition controller' },
    { url: root.dataset.leftUrl, title: 'LEFT SIDE', alt: 'Left side of the Sunset Edition controller' }
  ];

  views.forEach((view) => {
    if (!view.url) return;
    const image = new Image();
    image.src = view.url;
  });

  let currentView = 0;
  const galleryImage = root.querySelector('#gallery-image');
  const viewLabel = root.querySelector('#view-label');
  const tabs = [...root.querySelectorAll('[data-view]')];
  const stage = root.querySelector('.gallery-stage');

  function showView(index) {
    if (!galleryImage || !viewLabel || !tabs.length) return;
    currentView = ((index % views.length) + views.length) % views.length;
    const view = views[currentView];
    if (view.url) galleryImage.src = view.url;
    galleryImage.alt = view.alt;
    viewLabel.textContent = `0${currentView + 1} / ${view.title}`;
    tabs.forEach((tab, i) => {
      tab.classList.toggle('active', i === currentView);
      tab.setAttribute('aria-pressed', String(i === currentView));
    });
  }

  tabs.forEach((tab) => tab.addEventListener('click', () => showView(Number(tab.dataset.view))));
  root.querySelector('.previous')?.addEventListener('click', () => showView(currentView - 1));
  root.querySelector('.next')?.addEventListener('click', () => showView(currentView + 1));
  root.querySelector('.gallery-tabs')?.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    showView(currentView + (event.key === 'ArrowRight' ? 1 : -1));
    tabs[currentView]?.focus();
  });

  if (stage) {
    let gesture = null;
    stage.addEventListener('dragstart', (event) => event.preventDefault());
    stage.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || event.button !== 0 || event.target.closest('button')) return;
      gesture = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        startView: currentView,
        step: Math.max(45, Math.min(90, stage.clientWidth / 5)),
        horizontal: false
      };
    });
    stage.addEventListener('pointermove', (event) => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.horizontal) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) { gesture = null; return; }
        gesture.horizontal = true;
        stage.setPointerCapture(event.pointerId);
        stage.classList.add('is-dragging');
      }
      const next = gesture.startView + Math.trunc(-dx / gesture.step);
      const normalized = ((next % views.length) + views.length) % views.length;
      if (normalized !== currentView) showView(normalized);
    });
    function endGesture(event) {
      if (!gesture || event.pointerId !== gesture.id) return;
      gesture = null;
      stage.classList.remove('is-dragging');
      if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
    }
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((type) => stage.addEventListener(type, endGesture));
    stage.addEventListener('keydown', (event) => {
      if (event.target !== stage || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      showView(currentView + (event.key === 'ArrowRight' ? 1 : -1));
    });
  }

  const dialog = root.querySelector('#purchase-dialog');
  const acknowledgment = root.querySelector('#checkout-ack');
  const mainAcknowledgment = root.querySelector('#main-order-ack');
  const checkoutForm = root.querySelector('#checkout-form');
  const continueCheckout = root.querySelector('#continue-checkout');
  const checkoutStatus = root.querySelector('#checkout-status');

  function syncAcknowledgment() {
    if (!continueCheckout || !acknowledgment) return;
    continueCheckout.disabled = !productReady || !acknowledgment.checked;
  }

  root.querySelectorAll('[data-buy]').forEach((button) => button.addEventListener('click', () => {
    if (!dialog || !acknowledgment || !checkoutStatus) return;
    acknowledgment.checked = Boolean(mainAcknowledgment?.checked);
    checkoutStatus.textContent = productReady
      ? 'Review and accept the made-to-order terms to continue.'
      : root.dataset.unavailableMessage || 'This product is not available for checkout yet.';
    syncAcknowledgment();
    dialog.showModal();
  }));

  acknowledgment?.addEventListener('change', syncAcknowledgment);

  checkoutForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!acknowledgment?.checked || !checkoutForm.reportValidity()) return;
    if (!productReady) {
      if (checkoutStatus) checkoutStatus.textContent = root.dataset.unavailableMessage || 'This product is not available for checkout yet.';
      return;
    }

    if (continueCheckout) continueCheckout.disabled = true;
    if (checkoutStatus) checkoutStatus.textContent = 'Adding your controller and opening secure checkout…';

    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(checkoutForm)
      });
      if (!response.ok) {
        let message = 'We could not add the controller to your cart. Please try again.';
        try {
          const data = await response.json();
          message = data.description || data.message || message;
        } catch (_) {}
        throw new Error(message);
      }
      window.location.assign(checkoutUrl);
    } catch (error) {
      if (checkoutStatus) checkoutStatus.textContent = error.message || 'Checkout could not be opened. Please try again.';
      syncAcknowledgment();
    }
  });

  root.querySelector('.close-dialog')?.addEventListener('click', () => dialog?.close());
  root.querySelectorAll('a[href="#return-policy"]').forEach((link) => link.addEventListener('click', () => {
    const policy = root.querySelector('#return-policy');
    if (policy) policy.open = true;
    if (dialog?.open) dialog.close();
  }));

  dialog?.addEventListener('click', (event) => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) {
      dialog.close();
    }
  });
})();
